import * as React from 'react';
import { useSelector } from 'react-redux';

import { ReviewsFixedFooterLayout, ReviewsLayout } from '../../components/ReviewsLayout';
import { RatingsFilterContainer } from '../RatingsFilter';
import { MoreReviewsButtonContainer } from '../MoreReviewsButton';
import { NewReviewButtonContainer } from '../NewReviewButton';
import { RatingsTagsContainer } from '../RatingsTags';
import { ReviewsSortContainer } from '../ReviewsSortContainer';
import { TabsHeaderContainer } from '../TabsHeader/TabsHeader';
import { TabsContainer } from '../Tabs';
import { ItemsListContainer } from '../ItemsList';
import { ModerationLink } from '../../components/ModerationLink';
import { NewQuestionButtonContainer } from '../NewQuestionButton/NewQuestionButtonContainer';
import { getIsQuestionTab } from '../../selectors/tabs';
import { MoreQuestionsButtonContainer } from '../MoreQuestionsButton';

export function ReviewsContainer(): React.JSX.Element {
  const isQuestionTab = useSelector(getIsQuestionTab);

  return (
    <ReviewsLayout
      title={<TabsHeaderContainer />}
      tabs={<TabsContainer />}
      itemsList={<ItemsListContainer />}
      itemsSort={<ReviewsSortContainer />}
      moreReviewsButton={isQuestionTab ? <MoreQuestionsButtonContainer /> : <MoreReviewsButtonContainer />}
      fixedFooter={
        <ReviewsFixedFooterLayout
          review={<NewReviewButtonContainer />}
          moderation={<ModerationLink />}
          question={<NewQuestionButtonContainer fill="fill_secondary" />}
        />
      }
      ratingsFilter={<RatingsFilterContainer />}
      tags={<RatingsTagsContainer />}
    />
  );
}
